export default __webpack_public_path__ + "static/media/amos_bow.e97cd305.png";